import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/Home'
import About from '@/views/About'
import Contact from '@/views/Contact'
import Services from '@/views/Services'
import Gdpr from '@/views/document/Gdpr'
import Cookies from '@/views/document/Cookies'
import TermsAndConditions from '@/views/document/TermsAndConditions'
import ReturnPolicy from '@/views/document/ReturnPolicy'
import PersonalAccount from '@/views/account/PersonalAccount'
import PersonalOrders from '@/views/account/PersonalOrders'
import Main from '@/views/auth/components/Main'
import Auth from '@/views/auth/Auth'
import ResetPassword from '@/views/auth/components/ResetPassword'
import ForgotPassword from '@/views/auth/components/ForgotPassword'
import Unauthorized from '@/views/errors/Unauthorized'

// import Data from '@/views/data/DataView'
// import DataDashboard from '@/views/data/Dashboard'
import Cutting from '@/views/cutting/Cutting'
// import Customers from '@/views/data/Customers'
// import CustomerDetail from '@/views/data/CustomerDetail'
// import Orders from '@/views/data/Orders'
// import OrderDetail from '@/views/data/OrderDetail'
// import Products from '@/views/data/Products'
// import ProductDetail from '@/views/data/ProductDetail'



// import ModelPanels from '@/components/modeling/ModelPanels'
// import Rozmery from '@/components/modeling/korpus/Rozmery'
// import TypyKorpusov from '@/components/modeling/korpus/TypyKorpusov'
import store from '@/store/index'
// import * as types from '@/store/types'

Vue.use(Router)


const router = new Router({
  mode: 'hash',
  routes: [
    // *************************** DEFAULT
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/about',
      name: 'About',
      component: About
    },
    {
      path: '/contact',
      name: 'Contact',
      component: Contact
    },
    {
      path: '/services',
      name: 'Services',
      component: Services
    },
    {
      path: '/gdpr',
      name: 'Gdpr',
      component: Gdpr
    },
    {
      path: '/cookies',
      name: 'Cookies',
      component: Cookies
    },
    {
      path: '/terms-and-conditions',
      name: 'TermsAndConditions',
      component: TermsAndConditions
    },
    {
      path: '/return-policy',
      name: 'ReturnPolicy',
      component: ReturnPolicy
    },
    {
      path: '/account',
      name: 'account',
      component: PersonalAccount,
      meta: {
        requiresAuth: true
      },
    },
    {
      path: '/orders',
      name: 'orders',
      component: PersonalOrders,
      meta: {
        requiresAuth: true
      },
    },
    // *************************** AUTH
    {
      path: '/auth',
      component: Main,
      children: [{
        path: '',
        name: 'Auth',
        component: Auth
      }, {
        path: 'forgotpassword',
        name: 'ForgotPassword',
        component: ForgotPassword
      }, {
        path: 'reset-password',
        name: 'ResetPassword',
        component: ResetPassword
      }]
    },
    {
      path: '/401',
      name: 'unauthorized',
      component: Unauthorized
    },
    {
      path: '/cutting',
      name: 'cutting',
      component: Cutting,
      meta: {
        requiresAuth: true
      },
    },
    {
      path: '*',
      redirect: '/'
    }
  ],
  scrollBehavior() {
    return {
      x: 0,
      y: 0
    }
  }
})

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    if (store.getters.isAuthenticated == false) {
      next({
        path: '/auth',
        query: {
          redirect: to.fullPath
        }
      })
    } else {
      next()
    }
  } else {
    next() // make sure to always call next()!
  }
})

export default router